import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { Icon, toAbsoluteUrl } from '../../../helpers'
import { useLayout } from '../../core'
import { MutableRefObject, useEffect, useRef, useState } from 'react'
import { ToggleComponent } from '../../../assets/ts/components'
import { useAuth } from '../../../../app/modules/auth'

type PropsType = {
  sidebarRef: MutableRefObject<HTMLDivElement | null>
}

const SidebarLogo = (props: PropsType) => {
  const { currentUser } = useAuth()

  const { config } = useLayout()
  const toggleRef = useRef<HTMLDivElement>(null)

  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(
    config.app?.sidebar?.default?.minimize?.desktop?.default ?? false
  )

  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? 'collapse'
    : appSidebarDefaultMinimizeDesktopEnabled
      ? 'minimize'
      : ''
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
  // const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default

  useEffect(() => {
    setTimeout(() => {
      const toggleObj = ToggleComponent.getInstance(toggleRef.current!) as ToggleComponent | null

      if (toggleObj === null) {
        return
      }

      toggleObj.on('kt.toggle.change', function () {
        setIsSidebarOpen((prev) => !prev)
      })
    }, 600)
  }, [toggleRef, props.sidebarRef])

  return (
    <div className='app-sidebar-logo px-6' id='app_sidebar_logo' style={{ backgroundColor: '#00205B' }}>
      <Link to='/dashboard'>
        <img
          src={toAbsoluteUrl(
            isSidebarOpen
              ? '/media/avatars/logo_blanc_mobile.png'
              : '/media/avatars/Logo_White.png'
          )}
          alt=''
          className={isSidebarOpen ? 'w-100' : 'w-75'}
          style={{ transform: 'none', transition: 'none' }}
        />
      </Link>

      {(appSidebarDefaultMinimizeDesktopEnabled || appSidebarDefaultCollapseDesktopEnabled) && (
        <div
          ref={toggleRef}
          id='app_sidebar_toggle'
          className={clsx(
            'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary h-30px w-30px position-absolute top-50 start-100 translate-middle rotate',
            { active: isSidebarOpen }
          )}
          data-toggle='true'
          data-toggle-state={toggleState}
          data-toggle-target='body'
          data-toggle-name={`app-sidebar-${toggleType}`}
        >
          <Icon iconName='black-left-line' className='fs-3 rotate-180 ms-1' />
        </div>
      )}
    </div>
  )
}

export { SidebarLogo }
